import { useSearchParams } from "react-router-dom";
import { useLanguageShowQuery } from "@/admin/entities/languages";
import {
  getColumnsConfig,
  getMobileColumnsConfig,
  getTextsConfig,
} from "./config";
import { getTableData, mapColumns } from "./mappers";

export function useLanguagesManagement() {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  useLanguageShowQuery(id, id === null);

  return {
    columns: getColumnsConfig(),
    mobileColumns: getMobileColumnsConfig(),
    mapColumns,
    getTableData,
    texts: getTextsConfig(),
  };
}
